/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Button, Icon, Tooltip } from 'bold-ui'
import { MChatRiscoEnum } from 'graphql/types.generated'
import { useAtendimentoContext } from 'hooks/atendimento-context/useAtendimentoContext'
import { isEmpty } from 'lodash'

import { MChatRfAccordionSection } from '../../components/MChatRfAccordionSection'
import { MChatRfAccordionStepper } from '../../components/MChatRfAccordionStepper'
import { MChatRfAccordionSectionEnum } from '../../model-mChatRf'
import { convertMChatToPerguntaRespostaInput } from '../converter-mchat'
import { downloadMChat } from '../impressao/downloadMChat'
import { MChatAnteriorFooterInfoModel, MChatFieldModel } from '../model-mchat'

interface MChatViewProps {
  value: MChatFieldModel & MChatAnteriorFooterInfoModel
}

export function MChatView(props: Readonly<MChatViewProps>) {
  const { value } = props

  const {
    atendimentoProfissional: { id: atendProfId },
    cidadao: { id: cidadaoId },
  } = useAtendimentoContext()

  const hasValuesMChat = !isEmpty(value)

  const handlePrint = (mchat: MChatFieldModel) => {
    downloadMChat({
      atendProfId: hasValuesMChat ? value.atendimentoProfissionalId : atendProfId,
      cidadaoId: cidadaoId,
      resultado: mchat.resultado,
      risco: mchat.risco,
      aplicacao: convertMChatToPerguntaRespostaInput(mchat),
    })
  }

  return (
    <MChatRfAccordionSection
      section={MChatRfAccordionSectionEnum.MCHAT}
      value={value}
      stepper={
        <MChatRfAccordionStepper
          showPendingIcon={!hasValuesMChat}
          showCheckIcon={hasValuesMChat}
          showConnector={value?.risco === MChatRiscoEnum.MEDIO}
          showExclamationIcon={false}
        />
      }
      secondaryActions={
        <Tooltip text='Imprimir'>
          <Button type='button' kind='normal' skin='ghost' size='small' onClick={() => handlePrint(value)}>
            <Icon icon='printerOutline' />
          </Button>
        </Tooltip>
      }
      footerInfo={value}
    />
  )
}
